module.exports = __webpack_public_path__ + "static/merch3Front-7665f91492f914625d8cc88bd96988ab.png";